export default __webpack_public_path__ + "static/media/SWT0510.34I-20427_-14788_0.4cb423dc.jpg";